import type { AssetRef } from "@kss/schema";
import { useLoroSelector } from "../../sync/hooks";
import { MediaShell } from "../media/MediaShell";
import { derivativeUrl, useAsset } from "../media/useAsset";
import type { BlockComponentProps } from "../registry";
import { bodyMap } from "../textField";
import { useT } from "../../i18n";

/** Video block (spec §8.8): `<video controls preload="metadata">`; Range requests served by Caddy. */
export function VideoBlock({ handle, treeId, node, readOnly }: BlockComponentProps) {
  const t = useT();
  const body = bodyMap(node);
  const asset = (useLoroSelector(handle.doc, () => (body?.get("asset") as AssetRef | null) ?? null, (a, b) => a?.hash === b?.hash) ?? null) as AssetRef | null;
  const { upload, derivatives, stored, localUrl } = useAsset(asset?.hash ?? null);
  if (!body) return null;
  const src = stored ? `/api/assets/${asset?.hash}` : localUrl;
  const poster = derivativeUrl(derivatives, "poster") ?? undefined;
  return (
    <MediaShell handle={handle} treeId={treeId} body={body} accept="video/*" readOnly={readOnly} asset={asset} upload={upload}>
      {src ? <video controls preload="metadata" poster={poster} src={src} className="max-h-96 max-w-full rounded" data-testid="video-el" data-fill-media /> : <div className="text-sm text-neutral-500">{t("media.offline", { name: asset?.name ?? "" })}</div>}
    </MediaShell>
  );
}
